export default __webpack_public_path__ + "static/media/PashtunMap.bba91b65.jpg";